// extracted by mini-css-extract-plugin
export default {"a":"index_a_YGfmd"};